import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'
import { AIMetadataModel, aIMetadataUrl } from '@store/slices/aiMeta.slice'

export const approveOutline = createAsyncThunk(
  'aiMetadata/approve-outline',
  async (props: { aimetaId: EntityId }) => {
    try {
      const response = await api.get(
        `${aIMetadataUrl}${props.aimetaId}/approve-outline/`
      )
      return response.data as AIMetadataModel
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `${serverError.message || 'Nepodařilo se potvrdit outline pro slot'}`
        )
      } else {
        toast.error('Nepodařilo se potvrdit outline pro slot')
      }
      throw axiosError
    }
  }
)

export const fetchAllMetadataBySlotIds = createAsyncThunk(
  'aiMetadata/fetchBySlotIds',
  async (aiSlotIds: EntityId[]) => {
    try {
      const response = await api.get(
        `${aIMetadataUrl}?ai_slotId__in=${aiSlotIds.join(',')}`
      )
      return response.data as AIMetadataModel[]
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `${serverError.message || 'Nepodařilo se potvrdit outline pro slot'}`
        )
      } else {
        toast.error('Nepodařilo se potvrdit outline pro slot')
      }
      throw axiosError
    }
  }
)
